import { render, staticRenderFns } from "./Sig.vue?vue&type=template&id=33338631&scoped=true&"
import script from "./Sig.vue?vue&type=script&lang=js&"
export * from "./Sig.vue?vue&type=script&lang=js&"
import style0 from "./Sig.vue?vue&type=style&index=0&id=33338631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33338631",
  null
  
)

export default component.exports